var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useRegisteredTranslation from '@dev-togetherprice/hooks.use-register-translation';
import en from './i18n/en.json';
import es from './i18n/es.json';
import it from './i18n/it.json';
import pt from './i18n/pt.json';
const TRANSLATIONS = { en, es, it, pt };
const useStripeTranslation = () => {
    const { t } = useRegisteredTranslation('useStripeTranslation', TRANSLATIONS);
    return { tStripe: t };
};
export const getStripeTranslations = (locale) => __awaiter(void 0, void 0, void 0, function* () {
    switch (locale) {
        case 'es':
        case 'ca':
            return es;
        case 'it':
            return it;
        case 'pt':
            return pt;
        case 'en':
        default:
            return en;
    }
});
export default useStripeTranslation;
